import {injectable} from 'inversify';

import {UserMetadataModel} from './UserMetadata.model';

@injectable()
export class UserMetadataFactory {
  create(props: UserMetadataModel.Props): UserMetadataModel {
    return new UserMetadataModel(props);
  }

  createEmpty(): UserMetadataModel {
    return new UserMetadataModel(UserMetadataFactory.EMPTY_PROPS);
  }
}

export namespace UserMetadataFactory {
  export const EMPTY_PROPS: UserMetadataModel.Props = {
    b2c_demo: {
      anxious: undefined,
      anything_else: undefined,
      coaching_style: undefined,
      code: undefined,
      partner_id: undefined,
      support: undefined,
      what_brings_you: undefined,
      worrying: undefined,
    },
    dtc_qrcode: {
      age: undefined,
      anxious: undefined,
      areas_of_wellbeing: undefined,
      coaching_style: undefined,
      obstacles: undefined,
      other_professionals: undefined,
      worrying: undefined,
    },
    employee: {
      anxious: undefined,
      anything_else: undefined,
      coaching_style: undefined,
      support: undefined,
      what_brings_you: undefined,
      worrying: undefined,
    },
    employer: {
      code: undefined,
      company_name: undefined,
      invalid_code: undefined,
      position: undefined,
    },
    fd_onboarding: {
      is_finished: undefined,
    },
    is_b2c_demo_coach: undefined,
    is_dtc: undefined,
    last_used_coupon_id: undefined,
    onboarding: {
      account_type: undefined,
      coupon_reservation: undefined,
      /** @type date.toISOString */
      finished: undefined,
      invites_count: undefined,
      is_finished: undefined,
    },
    settings: {
      dont_show_phone_number_request: undefined,
      /** @type date.toISOString */
      phone_number_request_shown_at: undefined,
      weight_unit: undefined,
    },
    tracking: undefined,
  };
}
